import { TAB_TYPE_ROUNDED, TAB_TYPE_SQUARED, TabContentProps } from '../tabs.type';

import { RoundedTabs } from './rounded-tabs';
import { SimpleTabs } from './simple-tabs';
import { SquaredTabs } from './squared-tabs';

export const TabContent = ({ type, tabs, onChange, activeTab, showBackground, roundedVariant }: TabContentProps) => {
  if (type === TAB_TYPE_ROUNDED)
    return <RoundedTabs tabs={tabs} onChange={onChange} activeTab={activeTab} variant={roundedVariant} />;
  if (type === TAB_TYPE_SQUARED)
    return <SquaredTabs tabs={tabs} onChange={onChange} activeTab={activeTab} showBackground={showBackground} />;
  return <SimpleTabs tabs={tabs} onChange={onChange} activeTab={activeTab} />;
};
